import {gql} from 'apollo-angular';

export const ImageFragment = gql`
  fragment imageFields on Image {
    info {
      caption
      copyright
      alttext
    }
    portrait {
      url
      width
    }
    landscape {
      url
      width
    }
    large {
      url
      width
    }
    xlarge {
      url
      width
    }
    huge {
      url
      width
    }
    medium {
      url
      width
    }
  }`;
